<template lang="pug">
.card.i_p_6
  .card_title.flex_h.justify-content-start.align-items-center(@click="expand")
    img(:src="paymentInfo.area02_PayServiceList_Icon")
    h4.i_mt_1.i_mt_sm_0.i_ml_4 {{ paymentInfo.area02_PayServiceList_Title }}
    svg-icon.d-md-none(
      iconClass="arrow_bottom_g",
      className="arrow_bottom_g",
      :class="{ expand: isExpand }"
    )
  .card_title_cover.d-none.d-md-block
  .card_expand_content(:class="{ expand: isExpand }")
    pre.i_mt_2 {{ paymentInfo.area02_PayServiceList_Content }}
    a.text-center(
      v-if="paymentInfo.area02_PayServiceList_LinkName",
      :href="paymentInfo.area02_PayServiceList_LinkURL",
      target="_blank"
    ) {{ paymentInfo.area02_PayServiceList_LinkName }}
</template>

<script>
export default {
  name: "Card",
  props: {
    paymentInfo: Object,
  },
  data() {
    return {
      isExpand: false,
    };
  },
  methods: {
    expand() {
      this.isExpand = !this.isExpand;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/customer_service/card";
</style>
